module.exports = __webpack_public_path__ + "img/case-logo-18.89bceed8.png";